module.exports = __webpack_public_path__ + "img/icon运动员等级_职工五级@3x.2353047e.png";